import React from 'react';
import { Alert, Box, Link, SpaceBetween } from '@amzn/awsui-components-console';
import {
  ACTIVE_PACKAGES_ROUTE,
  CONFERENCE_BRANCH_MANAGEMENT_URL,
} from './ConferencePages/conferenceInfo/ui/PackagesEditor/permissionConstants';
import { AskFusionAssistantButton } from './fusionAssistant/AskFusionAssistantButton';
import { FusionAssistantContext } from './fusionAssistant/seedPrompt';

interface CrossVenueWarningProps {
  fusionContext?: FusionAssistantContext;
}

/**
 * Non-blocking hint shown when a task or group has a package that is also held
 * by an entity in another venue. Generic by design — it does not name the
 * specific package/venue/owner; it points the writer at the Active Packages
 * page for specifics and at the branch-management guidance to coordinate a
 * single branch manager.
 */
export const CrossVenueWarning = ({
  fusionContext,
}: CrossVenueWarningProps) => (
  <Alert
    statusIconAriaLabel='Warning'
    type='warning'
    header='Package shared across venues'
  >
    <Box variant='p'>
      One or more of your packages is shared with tasks or groups in other
      venues, so cross-venue branch coordination is needed. Nominate a single
      branch manager for the shared package.
    </Box>
    <SpaceBetween size='xs'>
      <Link href={ACTIVE_PACKAGES_ROUTE}>
        See which packages are shared (Active Packages)
      </Link>
      <Link external target='_blank' href={CONFERENCE_BRANCH_MANAGEMENT_URL}>
        Conference branch management guidance
      </Link>
      <AskFusionAssistantButton
        context={fusionContext}
        variant='inline-link'
        label='Ask Fusion Assistant about cross-venue packages'
        dataTestId='cross-venue-fusion-assistant-button'
      />
    </SpaceBetween>
  </Alert>
);
